import Base from './Base';

const ENTITY = 'news';
export const REDUCER_NAME = 'newsDetail';

const initialState = { isFetching: true, isSingleObject: true, values: {} };
const news = new Base(REDUCER_NAME, initialState);

export const reducer = news.reducer.bind(news);
news.getAsync.bind(news);

export const get = (id) => {
  return news.getAsync(`${ENTITY}/${id}`);
};



// WEBPACK FOOTER //
// ./src/redux/modules/news-detail.js